import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  page: {
    [theme.breakpoints.down('sm')]: {
      marginTop: `${theme.spacing(-14)} !important`,
    },
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: theme.spacing(2, 0),
    '& > *': {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
}))
